import * as React from "react";
import { Transition } from "react-transition-group";
import { GridCollapseContext } from "../grid-collapse-provider/grid-collapse-provider.mjs";
const GridCollapseTrigger = (props) => {
  const { isOpen, toggle } = React.useContext(GridCollapseContext);
  const elementRef = React.useRef(null);
  const renderContent = (state) => {
    return React.Children.map(props.children, (ch) => {
      const classArray = ["grid-collapse-trigger"];
      if (state) {
        classArray.push("grid-collapse-trigger--".concat(state));
      }
      if (React.isValidElement(ch)) {
        return React.cloneElement(ch, {
          ref: elementRef,
          className: classArray.join(" "),
          isActive: isOpen,
          onClick: (event) => {
            event.preventDefault();
            if (ch.props.onClick) {
              ch.props.onClick(event);
            }
            if (toggle) {
              toggle();
            }
          }
        });
      }
    });
  };
  if (props.fadeOutOnOpen) {
    return /* @__PURE__ */ React.createElement(Transition, { in: !isOpen, timeout: { exit: 150 }, nodeRef: elementRef }, renderContent);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderContent());
};
export {
  GridCollapseTrigger
};
